const Icon = {
  Industrial: () => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 40h36M9 40V22l7 6V22l7 6V22l7 6V22l7 6v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 22l3-8h4l3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Robot: () => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="14" y="16" width="20" height="16" rx="3" stroke="currentColor" strokeWidth="2" />
      <circle cx="20" cy="24" r="2" fill="currentColor" />
      <circle cx="28" cy="24" r="2" fill="currentColor" />
      <path d="M24 16V8m-6 0h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M14 36h20M18 32v6m12-6v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  Machine: () => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="10" width="32" height="10" rx="1" stroke="currentColor" strokeWidth="2" />
      <path d="M14 20v18M34 20v18M8 38h32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M20 24h8v8h-8z" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  Mould: () => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 14h28v8H10z" stroke="currentColor" strokeWidth="2" />
      <path d="M14 22v6a4 4 0 004 4h12a4 4 0 004-4v-6" stroke="currentColor" strokeWidth="2" />
      <path d="M20 32v4m8-4v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  Reliability: () => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 30l8-10 6 6 10-14 8 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 38h36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  Experience: () => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 6l16 8-16 8-16-8 16-8z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M12 20v10c0 4 6 7 12 7s12-3 12-7V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  Certified: () => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="8" width="20" height="26" rx="1" stroke="currentColor" strokeWidth="2" />
      <path d="M14 16h12M14 21h12M14 26h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="32" cy="30" r="7" stroke="currentColor" strokeWidth="2" />
      <path d="M29 30l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Holistic: () => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="16" stroke="currentColor" strokeWidth="2" />
      <path d="M24 8v32M8 24h32" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 3" />
      <circle cx="24" cy="24" r="4" fill="currentColor" />
    </svg>
  ),
  ChevronLeft: () => (
    <svg viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
  ),
  ChevronRight: () => (
    <svg viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
  ),
  Phone: () => (
    <svg viewBox="0 0 24 24" fill="none"><path d="M6 3h3l2 5-2.5 1.5a11 11 0 005 5L15 12l5 2v3a2 2 0 01-2 2A16 16 0 014 6a2 2 0 012-2z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
  ),
  Clock: () => (
    <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" /><path d="M12 7v5l4 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>
  ),
  Pin: () => (
    <svg viewBox="0 0 24 24" fill="none"><path d="M12 21s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z" stroke="currentColor" strokeWidth="1.6" /><circle cx="12" cy="9" r="2.4" stroke="currentColor" strokeWidth="1.6" /></svg>
  ),
  Mail: () => (
    <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" /><path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>
  ),
  Globe: () => (
    <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" /><path d="M3 12h18M12 3a14 14 0 010 18 14 14 0 010-18z" stroke="currentColor" strokeWidth="1.6" /></svg>
  ),
  Facebook: () => (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.5 21v-7.2h2.4l.4-2.8h-2.8V9.1c0-.8.2-1.4 1.4-1.4h1.5V5.1c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.2H8v2.8h2.5V21h3z" /></svg>
  ),
  LinkedIn: () => (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M6.9 8.4H3.9V20h3zM5.4 4a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6zM20.1 20v-6.4c0-3.4-1.8-5-4.2-5-1.9 0-2.8 1.1-3.3 1.8V8.4h-3v11.6h3v-6.5c0-.6.1-1.2.5-1.7a1.9 1.9 0 011.5-.8c1.1 0 1.9.7 1.9 2.4V20z" /></svg>
  ),
  YouTube: () => (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22 8.4s-.2-1.5-.8-2.2c-.8-.8-1.7-.8-2.1-.9C16.4 5 12 5 12 5s-4.4 0-7.1.3c-.4 0-1.3.1-2.1.9-.6.7-.8 2.2-.8 2.2S1.7 10.2 1.7 12v1.6c0 1.8.3 3.6.3 3.6s.2 1.5.8 2.2c.8.8 1.9.8 2.3.9C7.8 20.5 12 20.5 12 20.5s4.4 0 7.1-.3c.4 0 1.3-.1 2.1-.9.6-.7.8-2.2.8-2.2s.3-1.8.3-3.6V12c0-1.8-.3-3.6-.3-3.6zM9.8 15.5V9.9l5.6 2.8z" /></svg>
  ),
  Menu: () => (
    <svg viewBox="0 0 24 24" fill="none"><path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
  ),
  Close: () => (
    <svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
  ),
};

export default Icon;
